// import { createSelector } from 'reselect';

const selCreatePending = state => state.donations.createPending;

export default {
  createPending: selCreatePending,
};
